import React from "react";
import { Route, Switch } from "react-router-dom";
import Header from "./components/Header";
import Spinner from "./components/Spinner";
import PrivateRoute from "./components/PrivateRoute";
import Helmet from "react-helmet";
import "./App.css";
import whatsapp_logo from "./assets/whatsapp_logo.png";
import email_logo from "./assets/email_logo.png";

import routes from "./routes";

export default props => {
  return (
    <div id="container">
      <Helmet defaultTitle="Superheroes" titleTemplate="%s | Superheroes">
        <meta charSet="utf-8" />
        <script async src="https://www.googletagmanager.com/gtag/js?id=UA-144094694-1"></script>
        <script>
          {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'UA-144094694-1');
          `}
        </script>
      </Helmet>
      {<Header />}
      <Switch>
        {routes.map((route, i) => {
          if (route.auth) {
            return <PrivateRoute key={i} {...route} />;
          }
          return <Route key={i} {...route} />;
        })}
      </Switch>
      {props.isLoading && <Spinner />}
      
      <footer className="footer">
            <a href="https://wa.me/5491126864447?text=Hola%20quería%20hacerte%20una%20consulta:" className="phm white bgNone">
                <img src={whatsapp_logo} title="whatsapp" className="bgNone" alt="whatsapp"  height="30px"/>
              </a>
              <a href="mailto:atencionsuperheroes@mg54.com" className="phm white bgNone">
                <img src={email_logo} title="email" className="bgNone" alt="email" height="30px" />
              </a>
              <p className="white">Las consultas de WhatsApp se reciben de Lunes a Viernes hábiles de 9 a 18hs y se responden el mismo día dentro de ese horario.</p>
      </footer>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/Render.js